import { Editor } from 'grapesjs';
import React from 'react';
import { createRoot } from 'react-dom/client';

type TParams = {
  editor: Editor;
  panelName: string;
  elementId: string;
  element: React.ReactElement;
};

export const addElementToPanel = ({ editor, panelName, element, elementId }: TParams) => {
  const previewButtonContainer = document.createElement('div');
  const id = `${elementId}-container`;

  editor.Panels.addButton(panelName, {
    id: elementId,
    content: previewButtonContainer.outerHTML,
    attributes: { id },
  });

  const container = document.getElementById(id);
  if (container) {
    const root = createRoot(container);
    root.render(element);
  }
};
